import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import type { ITopWorkerClients } from '@/entities/admin-stats.entity';
import { UsersIcon } from 'lucide-react';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';

interface TopWorkersClientsChartProps {
	data: ITopWorkerClients[];
}

const chartConfig = {
	clientsCount: { label: 'Клиенты', color: 'var(--chart-3)' },
};

export default function TopWorkersClientsChart({ data }: TopWorkersClientsChartProps) {
	const chartData = data.map(d => ({
		name: `#${d.nickname}`,
		clientsCount: d.clientsCount,
	}));

	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-3'>
				<div className='flex items-center gap-2'>
					<div className='rounded-lg bg-chart-3/15 p-1.5'>
						<UsersIcon className='text-chart-3' size={16} />
					</div>
					<CardTitle className='text-sm'>Топ воркеров по клиентам</CardTitle>
				</div>
			</CardHeader>
			<CardContent className='px-2 py-3'>
				{chartData.length === 0 ? (
					<div className='h-[200px] flex items-center justify-center text-sm text-muted-foreground'>Нет данных</div>
				) : (
					<ChartContainer config={chartConfig} className='w-full' style={{ height: Math.max(200, chartData.length * 36) }}>
						<BarChart data={chartData} layout='vertical' margin={{ top: 0, right: 8, left: 0, bottom: 0 }}>
							<CartesianGrid strokeDasharray='3 3' horizontal={false} />
							<XAxis type='number' tickLine={false} axisLine={false} tick={{ fontSize: 10 }} allowDecimals={false} />
							<YAxis type='category' dataKey='name' tickLine={false} axisLine={false} tick={{ fontSize: 10 }} width={80} />
							<ChartTooltip content={<ChartTooltipContent />} />
							<Bar dataKey='clientsCount' fill='var(--chart-3)' radius={[0, 4, 4, 0]} />
						</BarChart>
					</ChartContainer>
				)}
			</CardContent>
		</Card>
	);
}
